<template>
  <div class="d-flex justify-end px-2 py-2">
    <div
      class="d-flex align-center"
      style="background: #fff; border: 1px solid #1976d2; border-radius: 24px; padding: 3px 6px; gap: 2px; box-shadow: 0 1px 4px rgba(25,118,210,0.2)"
    >
      <span
        class="font-weight-medium primary--text text-uppercase mr-1"
        style="letter-spacing: 0.06em; font-size: 10px; padding-left: 8px"
      >Participantes</span>
      <v-btn
        icon
        small
        color="primary"
        :disabled="pagina <= 1"
        @click="$emit('mudar', -1)"
      >
        <v-icon small>mdi-chevron-left</v-icon>
      </v-btn>
      <span
        class="body-2 font-weight-bold primary--text"
        style="min-width: 46px; text-align: center; letter-spacing: 0.5px"
      >{{ pagina }} / {{ total }}</span>
      <v-btn
        icon
        small
        color="primary"
        :disabled="pagina >= total"
        @click="$emit('mudar', 1)"
      >
        <v-icon small>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApuracaoPaginador",

  props: {
    pagina: { type: Number, required: true },
    total:  { type: Number, required: true }
  }
};
</script>
